import { type FC } from "react";

import { Spinner, TooltipIndicator } from "@snapchat/snap-design-system";

import { type Visibility } from "../../gql-generated/types";
import { Flexbox } from "../../shared/components";

import {
    LensVisibilityLabelCompactContainer,
    LensVisibilityLabelCompactIcon,
} from "./LensVisibilityLabelCompact.styles";
import {
    VISIBILITY_OPTION_DESCRIPTION_MAP,
    VISIBILITY_OPTION_ICON_MAP,
    VISIBILITY_OPTION_LABEL_MAP,
} from "./constants";

interface LensVisibilityLabelCompactProps {
    visibility: Visibility;
    loading: boolean;
    disabled: boolean;
}

export const LensVisibilityLabelCompact: FC<LensVisibilityLabelCompactProps> = ({ visibility, loading }) => {
    const VisibilityIcon = VISIBILITY_OPTION_ICON_MAP[visibility];
    return (
        <LensVisibilityLabelCompactContainer>
            <Flexbox>
                <VisibilityIcon />
                {VISIBILITY_OPTION_LABEL_MAP[visibility]}
            </Flexbox>

            <LensVisibilityLabelCompactIcon>
                {loading ? <Spinner /> : <TooltipIndicator content={VISIBILITY_OPTION_DESCRIPTION_MAP[visibility]} />}
            </LensVisibilityLabelCompactIcon>
        </LensVisibilityLabelCompactContainer>
    );
};
